export default "__VITE_ASSET__CwO89jCv__"